// Environnement de production
export const environment = {
  production: true,
  apiUrl: 'https://api.preprod.lvdm28.fr',
  appName: 'ADAPEI 28',
  
  // Configuration Userback - Collecte de feedback utilisateur
  userback: {
    enabled: true, // Activé en production
    token: 'A-4wdIRIublHjbjj6zXgKh2cD8Y', // Remplacez par votre token Userback
    settings: {
      language: 'fr',
      main_button_background_colour: '#3B82F6',
      position: 'right',
      categories: ['bug', 'feature_request', 'general'],
      auto_screenshot: true,
      // En production, vous pouvez masquer le widget pour certains rôles
      // hide_for_roles: ['admin'] // Exemple
    }
  }
};

// Note: Les routes d'authentification utilisent https://api.adapei28.fr/auth/*
// Les autres routes API utilisent https://api.adapei28.fr/api/*
